import { usePlatformSettings } from "@/hooks/usePlatformSettings";

const FALLBACK_NUMBER = "";

/**
 * Botón flotante de WhatsApp (responsivo).
 * Usa `contact_whatsapp` de platform_settings; si no hay número, no se muestra.
 */
export function WhatsAppFloatingButton() {
    const { getSetting } = usePlatformSettings();
    const raw = (getSetting('contact_whatsapp', '') as string) || FALLBACK_NUMBER;
    const digits = (raw || "").replace(/[^\d]/g, "");

    if (!digits) return null;

    const message = encodeURIComponent("Hola, tengo una duda sobre RepasoGPC.");

    return (
        <a
            href={`https://wa.me/${digits}?text=${message}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escríbenos por WhatsApp"
            className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-black/20 transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#25D366] sm:bottom-6 sm:right-6"
        >
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6 shrink-0" aria-hidden="true">
                <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.92-2.19-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.46 0 1.45 1.06 2.85 1.21 3.05.15.2 2.09 3.2 5.07 4.37 2.98 1.16 2.98.77 3.52.72.54-.05 1.75-.71 2-1.4.25-.68.25-1.27.17-1.39-.07-.12-.27-.19-.57-.34z" />
                <path d="M12.04 2C6.6 2 2.18 6.42 2.18 11.86c0 1.74.45 3.44 1.32 4.94L2 22l5.36-1.4c1.44.79 3.06 1.2 4.7 1.2 5.43 0 9.85-4.42 9.85-9.86C21.9 6.42 17.48 2 12.04 2zm0 17.94c-1.5 0-2.97-.4-4.25-1.16l-.3-.18-3.17.83.85-3.1-.2-.32a8.1 8.1 0 0 1-1.25-4.35c0-4.48 3.65-8.13 8.14-8.13 4.48 0 8.13 3.65 8.13 8.13 0 4.49-3.65 8.28-7.95 8.28z" />
            </svg>
            <span className="hidden sm:inline">WhatsApp</span>
        </a>
    );
}

export default WhatsAppFloatingButton;
